import { addPrefix, commasForNumbers, numFormatterWithSuffix } from './helper';
import { MonthMap } from './EditDuration';
import moment from 'moment';
import { CostValues, MemberValues, TotalCost } from './summaryReportHelper';

export const titleAndSubtitles = {
  chronic: {
    title: 'Chronic Condition Cohort',
    pageTitle: 'Chronic Condition Comorbidity',
    subTitle:
      'Create cohorts of members with one or multiple chronic conditions to analyze their PMPM costs, drug usage patterns, and identify the list of members with these conditions.',
  },
  cost: {
    title: 'High Cost Claimants Cohort',
    pageTitle: 'High Cost Claimants Cohort',
    subTitle:
      'Identify members with an average monthly cost of care greater than the selected threshold and analyze these members',
  },
  drugs: {
    title: 'Multiple Drugs Consumption Cohort',
    pageTitle: 'Multiple Drugs Consumption Cohort',
    subTitle:
      'Identify members based on the number of drugs they consume simultaneously, analyze high drug consumption, drug usage patterns, therapeutic class overlap, and adherence.',
  },
  members: {
    title: 'Members List',
    subTitle:
      'Create or edit your list by selecting the cohort button on right.',
  },
  CARDS: {
    MEMBERS: 'Cohort Members',
    TOTAL_COST: 'Cohort Cost',
    PMPM: 'Cohort PMPM',
    PEPM: 'Cohort PEPM',
  },
  NO_DATA: 'No data available',
  MEMBER_TABLE: {
    title: 'Member Details',
    subTitle: 'List of members with more than 1 drug',
  },
};

export const formatTotalCost = (data: any, decimalDigits: number = 1) => {
  const totalCost: TotalCost = {
    totalCost: '$0.00',
    totalRx: '$0.00',
    totalMedical: '$0.00',
  };

  totalCost.totalRx = addPrefix(
    '$',
    numFormatterWithSuffix(data?.rxPaid ?? 0, decimalDigits),
  );
  totalCost.totalMedical = addPrefix(
    '$',
    numFormatterWithSuffix(data?.medPaid ?? 0, decimalDigits),
  );
  totalCost.totalCost = addPrefix(
    '$',
    numFormatterWithSuffix(data?.totalPaid ?? 0, decimalDigits),
  );
  return totalCost;
};

export const formatCostValues = (data: any) => {
  const costValues: CostValues = {
    rx: '$0.00',
    medical: '$0.00',
    total: '$0.00',
  };
  costValues.rx = '$' + commasForNumbers(String(data?.rxPaid ?? '0'), 2);
  costValues.medical = '$' + commasForNumbers(String(data?.medPaid ?? '0'), 2);
  costValues.total = '$' + commasForNumbers(String(data?.totalPaid ?? '0'), 2);
  return costValues;
};

export const formatMemberValues = (data: any) => {
  const memberValues: MemberValues = {
    members: '0',
    employees: '0',
    dependents: '0',
  };

  let total = 0;

  data?.map((item: any) => {
    if (item?.member_relationship_desc === 'Employee') {
      memberValues.employees = commasForNumbers(item?.count);
      total += item?.count;
    } else if (item?.member_relationship_desc === 'Dependent') {
      memberValues.dependents = commasForNumbers(item?.count);
      total += item?.count;
    }
  });
  memberValues.members = commasForNumbers(total.toString());
  return memberValues;
};

export const getServiceStartYear = (month: string, year: number) => {
  const monthNumber = MonthMap.get(month)?.monthNumber;
  const defaultDate = new Date(monthNumber + '-01-' + year);

  const startYear = moment(defaultDate).subtract(11, 'months').year();

  return startYear;
};

export const formatMembers = (data: any) => {
  const memberValues: MemberValues = {
    members: '0',
    employees: '0',
    dependents: '0',
  };

  let totalMembers = 0;

  data?.forEach((item: any) => {
    const count = item?.count || 0;

    if (item?.member_relationship_desc === 'Dependent') {
      memberValues.dependents = count.toString();
    } else if (item?.member_relationship_desc === 'Employee') {
      memberValues.employees = count.toString();
    }

    totalMembers += count;
  });

  memberValues.members = totalMembers.toString();
  return memberValues;
};
